import type { BaseSelectionItem } from "@frend-digital/centra-types/selection";
import { getBaseUrl } from "../utils/getBaseUrl";

export const selectionItemToKlaviyoItem = (item: BaseSelectionItem) => {
  const baseUrl = getBaseUrl();

  return {
    ProductName: item.product?.name,
    ProductID: item.product?.productSku,
    SKU: item.product?.productSku,
    Categories: item.product?.categoryName,
    ImageURL: item.product?.media?.["standard"]?.[0],
    URL: `${baseUrl}/${item.product?.uri}`,
    Brand: "Blæst",
    Price: item.priceEach,
    ItemPrice: item.priceEach,
    Quantity: item.quantity,
  };
};
